const Index = () => {
    return <div>MindPrint v2</div>;
};

export default Index;
